import { useState } from "react";
import { t } from "../lib/sprache";

/**
 * Seitenweise Listen (Umbauten 03.11.2026, R-02/R-03): lange Listen zeigen zuerst eine Portion, „Weitere … anzeigen“ hängt
 * die nächste an, „Alle anzeigen“ den Rest. Filter, Suche und Sortierung wirken weiter auf die ganze Liste; ändert sich der
 * Schlüssel (Filter, Suche, Sortierung), beginnt die Liste wieder mit der ersten Portion.
 */
export function useSeitenweise<T>(rows: readonly T[], groesse: number, schluessel: string) {
  const [stand, setStand] = useState<{ schluessel: string; anzahl: number }>({ schluessel, anzahl: groesse });
  const anzahl = stand.schluessel === schluessel ? stand.anzahl : groesse;
  const sichtbar = anzahl >= rows.length ? rows : rows.slice(0, anzahl);
  return {
    sichtbar,
    anzahl,
    rest: Math.max(0, rows.length - sichtbar.length),
    groesse,
    mehr: () => setStand({ schluessel, anzahl: anzahl + groesse }),
    alle: () => setStand({ schluessel, anzahl: rows.length }),
  };
}

export function MehrLaden({ rest, groesse, onMehr, onAlle, einheit }: {
  rest: number;
  groesse: number;
  onMehr: () => void;
  onAlle: () => void;
  /** Was gezählt wird, Mehrzahl („Rechnungen“, „Hinweise“) */
  einheit: string;
}) {
  if (rest <= 0) return null;
  const naechste = Math.min(groesse, rest);
  return (
    <div className="row tk-umbau-mehr-laden" role="group" aria-label={t("Weitere Einträge", "More entries")}>
      <button type="button" onClick={onMehr}>{t(naechste === 1 ? "1 weitere anzeigen" : `${naechste} weitere anzeigen`, `Show ${naechste} more`)}</button>
      {rest > naechste && <button type="button" className="tk-linkbtn" onClick={onAlle}>{t(`Alle ${rest} weiteren ${einheit} anzeigen`, `Show all ${rest} more ${einheit}`)}</button>}
      <small>{t(`${rest} weitere ${einheit} sind noch nicht geladen.`, `${rest} more ${einheit} are not loaded yet.`)}</small>
    </div>
  );
}
